import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const dashboardApi = createApi({
  reducerPath: "dashboard",
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: ({year}) => ({
        url: `/admin/dashboard-data?user_year=${year}`,  // Assuming `/dashboard` is the endpoint for your dashboard data
        method: "GET",
      }),
      providesTags: ['Dashboard'], 
      transformResponse:(res)=>res?.body,  // Transform the response to return only the data part
    })
  }),
})

export const {
  useGetDashboardDataQuery,  // Hook for fetching the dashboard data,
} = dashboardApi;
